var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full", class: _vm.containerClasses }, [
    _c(
      "div",
      { staticClass: "leading-loose select-none", class: _vm.headingClasses },
      [_vm._v("Stay Connected")]
    ),
    _c(
      "div",
      {
        staticClass: "items-center justify-between lg_justify-start",
        class: _vm.linksClasses
      },
      [
        _c(
          "svg",
          {
            staticClass: "footer-svg",
            attrs: {
              tabindex: "0",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 13 25",
              fill: _vm.color ? "#475993" : "currentColor"
            },
            on: {
              click: function($event) {
                return _vm.linkClickFooter(
                  "https://www.facebook.com/ViralStyle/"
                )
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.linkClickFooter(
                  "https://www.facebook.com/ViralStyle/"
                )
              }
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M3.777 25V13.818H0V9.375h3.777V5.874C3.777 2.07 6.12 0 9.543 0c1.64 0 3.048.122           3.457.176V4.15h-2.373c-1.862 0-2.221.88-2.221 2.163v3.062h4.2l-.576 4.443H8.406V25"
              }
            })
          ]
        ),
        _c(
          "svg",
          {
            staticClass: "footer-svg",
            attrs: {
              tabindex: "0",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 26 21",
              fill: _vm.color ? "#03a9f4" : "currentColor"
            },
            on: {
              click: function($event) {
                return _vm.linkClickFooter("https://twitter.com/ViralstyleLLC")
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.linkClickFooter("https://twitter.com/ViralstyleLLC")
              }
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M23.327 5.234c.017.23.017.459.017.689C23.344 12.928 17.982 21 8.183 21c-3.02           0-5.824-.87-8.183-2.379.429.05.841.066 1.287.066a10.71 10.71 0 0 0 6.615-2.264           5.334 5.334 0 0 1-4.982-3.675c.33.049.66.082 1.006.082.479 0 .957-.066           1.403-.18-2.442-.493-4.273-2.626-4.273-5.202v-.065c.71.394 1.534.64 2.408.672A5.288           5.288 0 0 1 1.814.968a15.175 15.175 0 0 0 10.988 5.545A5.95 5.95 0 0 1 12.67 5.3C12.67           2.38 15.046 0 17.999 0c1.534 0 2.92.64 3.893 1.673 1.204-.23 2.36-.672 3.382-1.28a5.29           5.29 0 0 1-2.343 2.921A10.73 10.73 0 0 0 26 2.494a11.42 11.42 0 0 1-2.673 2.74z"
              }
            })
          ]
        ),
        _c(
          "svg",
          {
            staticClass: "footer-svg",
            attrs: {
              tabindex: "0",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 29 21",
              fill: _vm.color ? "#f44336" : "currentColor"
            },
            on: {
              click: function($event) {
                return _vm.linkClickFooter(
                  "https://www.youtube.com/channel/UCxAP2Z1coif3dEo02BdB7iw"
                )
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.linkClickFooter(
                  "https://www.youtube.com/channel/UCxAP2Z1coif3dEo02BdB7iw"
                )
              }
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M11.6 15V6l7.733 4.5zM28.394 3.286C28.06 1.992 27.078.974 25.83.628 23.57 0 14.5 0 14.5           0S5.431 0 3.17.628C1.922.974.94 1.992.606 3.286 0 5.63 0 10.52 0 10.52s0 4.891.606 7.236a3.643           3.643 0 0 0 2.564 2.615C5.43 21 14.5 21 14.5 21s9.069 0 11.33-.628a3.643 3.643 0 0 0           2.564-2.615C29 15.412 29 10.52 29 10.52s0-4.89-.606-7.235z"
              }
            })
          ]
        ),
        _c(
          "svg",
          {
            staticClass: "footer-svg",
            attrs: {
              tabindex: "0",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 21 25",
              fill: _vm.color ? "#cb2027" : "currentColor"
            },
            on: {
              click: function($event) {
                return _vm.linkClickFooter(
                  "https://www.pinterest.com/viralstyle/"
                )
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.linkClickFooter(
                  "https://www.pinterest.com/viralstyle/"
                )
              }
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M11.156 0C5.546 0 0 3.426 0 8.971c0 3.526 2.166 5.53 3.478 5.53.542 0 .853-1.383.853-1.773           0-.466-1.296-1.458-1.296-3.396 0-4.028 3.347-6.883 7.678-6.883 3.724 0 6.48 1.939 6.48 5.5 0           2.66-1.164 7.649-4.938 7.649-1.361 0-2.526-.902-2.526-2.194 0-1.893 1.444-3.727 1.444-5.68           0-3.316-5.135-2.715-5.135 1.292 0 .842.114 1.773.525 2.54-.755 2.975-2.297 7.408-2.297           10.473 0 .947.147 1.879.246 2.825.186.19.093.17.377.075 2.756-3.456 2.658-4.132 3.905-8.655.672           1.172 2.411 1.803 3.79 1.803C18.39 18.077 21 12.893 21 8.22 21 3.246 16.308 0 11.156 0z"
              }
            })
          ]
        ),
        _c(
          "svg",
          {
            staticClass: "footer-svg",
            attrs: {
              tabindex: "0",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 33 33"
            },
            on: {
              click: function($event) {
                return _vm.linkClickFooter(
                  "https://www.instagram.com/viralstyleofficial"
                )
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.linkClickFooter(
                  "https://www.instagram.com/viralstyleofficial"
                )
              }
            }
          },
          [
            _c(
              "defs",
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      x1: "16.31",
                      x2: "16.31",
                      y1: ".48",
                      y2: "32.74",
                      gradientUnits: "userSpaceOnUse",
                      id: _vm.id + "a"
                    }
                  },
                  [
                    _c("stop", {
                      attrs: { offset: "0", "stop-color": "#e09b3d" }
                    }),
                    _c("stop", {
                      attrs: { offset: ".3", "stop-color": "#c74c4d" }
                    }),
                    _c("stop", {
                      attrs: { offset: ".6", "stop-color": "#c21975" }
                    }),
                    _c("stop", {
                      attrs: { offset: "1", "stop-color": "#7024c4" }
                    })
                  ],
                  1
                ),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      x1: "16.31",
                      x2: "16.31",
                      y1: ".48",
                      y2: "32.74",
                      gradientUnits: "userSpaceOnUse",
                      id: _vm.id + "b"
                    }
                  },
                  [
                    _c("stop", {
                      attrs: { offset: "0", "stop-color": "#e09b3d" }
                    }),
                    _c("stop", {
                      attrs: { offset: ".3", "stop-color": "#c74c4d" }
                    }),
                    _c("stop", {
                      attrs: { offset: ".6", "stop-color": "#c21975" }
                    }),
                    _c("stop", {
                      attrs: { offset: "1", "stop-color": "#7024c4" }
                    })
                  ],
                  1
                ),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      x1: "24.75",
                      x2: "24.75",
                      y1: ".47",
                      y2: "32.79",
                      gradientUnits: "userSpaceOnUse",
                      id: _vm.id + "c"
                    }
                  },
                  [
                    _c("stop", {
                      attrs: { offset: "0", "stop-color": "#e09b3d" }
                    }),
                    _c("stop", {
                      attrs: { offset: ".3", "stop-color": "#c74c4d" }
                    }),
                    _c("stop", {
                      attrs: { offset: ".6", "stop-color": "#c21975" }
                    }),
                    _c("stop", {
                      attrs: { offset: "1", "stop-color": "#7024c4" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("path", {
              attrs: {
                fill: _vm.color ? "url(#" + _vm.id + "a)" : "currentColor",
                d:
                  "M29.33 23.108a6.434 6.434 0 0 1-6.434 6.434H9.715a6.434 6.434 0 0 1-6.434-6.434V9.927a6.434 6.434 0 0 1 6.434-6.434h13.18a6.434 6.434 0 0 1 6.435 6.434v13.18zM22.896.212H9.715C4.358.212 0 4.57 0 9.927v13.18c0 5.357 4.358 9.715 9.715 9.715h13.18c5.357 0 9.716-4.358 9.716-9.714V9.927c0-5.357-4.359-9.715-9.715-9.715z"
              }
            }),
            _c("path", {
              attrs: {
                fill: _vm.color ? "url(#" + _vm.id + "b)" : "currentColor",
                d:
                  "M16.305 21.67a5.154 5.154 0 1 1 0-10.306 5.154 5.154 0 0 1 0 10.307zm0-13.587c-4.65 0-8.434 3.784-8.434 8.434 0 4.65 3.784 8.434 8.434 8.434 4.65 0 8.434-3.783 8.434-8.434 0-4.65-3.783-8.434-8.434-8.434z"
              }
            }),
            _c("path", {
              attrs: {
                fill: _vm.color ? "url(#" + _vm.id + "c)" : "currentColor",
                d:
                  "M22.735 8.146a2.021 2.021 0 1 1 4.042 0 2.021 2.021 0 0 1-4.042 0z"
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }